const isPrefillLoading = ({ userDataLoading , isUserDataPrefilledBoolean , isMyAccountEnabled , optInsDataLoading  })=>{
    const isUserDataPrefillDone = !userDataLoading && typeof isUserDataPrefilledBoolean !== 'undefined';
    return isMyAccountEnabled && !isUserDataPrefillDone || optInsDataLoading;
};

export { isPrefillLoading };
//# sourceMappingURL=is-prefill-loading.js.map
